import { render, staticRenderFns } from "./CalendarDay.vue?vue&type=template&id=83ca590e"
import script from "./CalendarDay.ts?vue&type=script&lang=ts&external"
export * from "./CalendarDay.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports